export enum EPriceAlertTab {
  CURRENT_SYMBOL = 'CURRENT_SYMBOL',
  ALL_SYMBOLS = 'ALL_SYMBOLS'
}

export const MAX_ALERTS_PER_SYMBOL: number = 10;
export const MAX_ALERTS_FOR_ALL_SYMBOLS: number = 50;

export const MINIMUM_PERCENTAGE_VALUE = 0.01;
export const MAXIMUM_PERCENTAGE_VALUE = 100;
export const MINIMUM_PRICE_VALUE = 0;
export const MAXIMUM_PRICE_VALUE = 999999999.99;

export const DEFAULT_POINTS_STEP = 0.0001;
export const DEFAULT_SYMBOL_DECIMALS = 2;

export const DUPLICATE_CREATE_ERROR_MSG = 'Invalid create/update alert request - Duplicated target price and condition';
export const DUPLICATE_UPDATE_ERROR_MSG = 'Invalid update alert request - Duplicated target price and condition symbol';
export const MAX_TOTAL_ALERT_ERROR_MSG = 'Reach Maximum total number';
